const PrivacyContainer = () => {
    return (
        <div className="mx-auto flex flex-col w-full justify-center space-y-6">
            <div className="flex flex-col space-y-2 text-center">
                <h1 className="text-2xl font-semibold tracking-tight">
                    Política de privacidad
                </h1>
            </div>
            <p className="px-8 text-center text-sm text-muted-foreground">
                Aquí explicaremos la política de privacidad a nuestros clientes
            </p>
        </div>
    );
}

export default PrivacyContainer;